/* Przykładowe użycie w innym pliku (script.js)

import CookieConsent from './modules/cookie-consent.js';
const cookie = new CookieConsent({
  cookieWrapper: '.js-cookie-consent',
  cookieCancel: '.js-cookie-cancel',
  expirationDays: 30
});
*/
export default class CookieConsent {
	
	constructor(args){
        this.cookieWrapper = document.querySelector(args.cookieWrapper);
		this.cookieCancel = document.querySelector(args.cookieCancel);
		this.expirationDays = args.expirationDays;
        this.bindEvents();
    } 

	bindEvents() {
        this.cookieCancel.addEventListener('click', ()=>{
            this.hideConsent();
		});
		// check if cookie is already set
		(document.cookie.indexOf("cookie-consent") >= 0) ? '' : this.showConsent();
	}
	showConsent() {
		this.cookieWrapper.classList.add('is-active');
	}
	hideConsent() {
		this.cookieWrapper.classList.remove('is-active');
		// set cookie time expiration
		let expireTime = new Date();
		expireTime.setTime(expireTime.getTime() + (60 * 60 * 24 * 1000 * this.expirationDays));
		document.cookie = "cookie-consent=true; expires=" + expireTime.toGMTString();
	}
};




